




import Vue from 'vue'
import ApolloExample from '@/components/ApolloExample.vue'

export default Vue.extend({
  name: 'apollo',
  components: {
    ApolloExample,
  },
})
